export default () =>
  import(/* webpackChunkName: 'coffee/mini/gift-card' */ './GiftCard');
